import {
  type ComponentProps,
  type HTMLInputTypeAttribute,
  useState,
} from 'react';

import { cn } from '@lib/ui/cn';
import { Eye, EyeOff } from 'lucide-react';

import { Button } from './button';

interface IProps extends ComponentProps<'input'> {
  secure?: boolean;
}

export function Input({
  className,
  secure = false,
  type = 'text',
  ...props
}: IProps) {
  const [inputType, setInputType] = useState<HTMLInputTypeAttribute>(type);

  const handleToggleSecure = () => {
    setInputType((currentType) => {
      if (currentType === 'password') {
        return 'text';
      }
      return 'password';
    });
  };

  return (
    <div className={cn('relative', className)}>
      <input
        className={cn(
          'border-input file:text-foreground placeholder:text-muted selection:bg-tertiary selection:text-primary-foreground dark:aria-invalid:ring-destructive/50 ring-ring/10 dark:ring-ring/20 dark:outline-ring/40 outline-ring/50 aria-invalid:outline-destructive/60 dark:aria-invalid:outline-destructive aria-invalid:ring-destructive/20 aria-invalid:border-destructive/60 dark:aria-invalid:border-destructive focus-visible:border-secondary text-foreground shadow-xs aria-invalid:focus-visible:ring-2 aria-invalid:focus-visible:outline-none dark:aria-invalid:focus-visible:ring-2 flex h-9 w-full min-w-0 rounded-lg border bg-transparent px-3 py-1 text-base transition-all duration-300 file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-1 focus-visible:ring-2 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        )}
        data-slot="input"
        type={inputType}
        {...props}
      />
      <Button
        className={cn(
          'text-primary absolute right-0 top-0 h-full cursor-pointer px-3 py-2 hover:bg-transparent disabled:cursor-not-allowed disabled:opacity-50',
          !secure && 'hidden',
        )}
        disabled={props.disabled}
        onClick={handleToggleSecure}
        size="icon"
        title={inputType === 'password' ? 'Mostrar senha' : 'Ocultar senha'}
        type="button"
        variant="ghost">
        <Eye
          className={cn(inputType !== 'password' && 'hidden')}
          strokeWidth={1.5}
        />
        <EyeOff
          className={cn(inputType === 'password' && 'hidden')}
          strokeWidth={1.5}
        />
      </Button>
      <style>{`
					.hide-password-toggle::-ms-reveal,
					.hide-password-toggle::-ms-clear {
						visibility: hidden;
						pointer-events: none;
						display: none;
					}
				`}</style>
    </div>
  );
}
